// SPEC-097 — espejo de cv-printing-backend/src/modules/cotizaciones/domain/bolsaMachine.ts
// Única fuente de verdad de transiciones válidas en el frontend. El backend SIEMPRE
// revalida (RN-001) — este archivo solo sirve para habilitar/deshabilitar UI.

export enum EstadoBolsa {
  ACTIVA = 'ACTIVA',
  BORRADOR = 'BORRADOR',
  ENVIADA = 'ENVIADA',
  GANADA = 'GANADA',
  PERDIDA = 'PERDIDA',
  VENCIDA = 'VENCIDA',
  ANULADA = 'ANULADA',
  // SPEC-119 (RN-002/ADR-003): soft-delete de bolsa. Nunca aparece en listados/kanban.
  DISCARDED = 'DISCARDED',
}

export const TRANSICIONES_VALIDAS: Record<EstadoBolsa, EstadoBolsa[]> = {
  [EstadoBolsa.ACTIVA]: [EstadoBolsa.BORRADOR, EstadoBolsa.DISCARDED],
  [EstadoBolsa.BORRADOR]: [EstadoBolsa.ENVIADA, EstadoBolsa.ANULADA, EstadoBolsa.DISCARDED],
  [EstadoBolsa.ENVIADA]: [
    EstadoBolsa.GANADA,
    EstadoBolsa.BORRADOR,
    EstadoBolsa.PERDIDA,
    EstadoBolsa.VENCIDA,
    EstadoBolsa.ANULADA,
  ],
  [EstadoBolsa.VENCIDA]: [EstadoBolsa.BORRADOR],
  [EstadoBolsa.GANADA]: [],
  [EstadoBolsa.PERDIDA]: [],
  [EstadoBolsa.ANULADA]: [],
  [EstadoBolsa.DISCARDED]: [],
};

// Transiciones que solo el sistema puede disparar (job diario) — nunca por drag & drop de usuario.
export const TRANSICIONES_SOLO_SISTEMA: Partial<Record<EstadoBolsa, EstadoBolsa[]>> = {
  [EstadoBolsa.ENVIADA]: [EstadoBolsa.VENCIDA],
};

export const ESTADOS_TERMINALES: EstadoBolsa[] = [
  EstadoBolsa.GANADA,
  EstadoBolsa.PERDIDA,
  EstadoBolsa.ANULADA,
];

// Orden del kanban (§2.6 del prototipo, R-11)
export const ORDEN_KANBAN: EstadoBolsa[] = [
  EstadoBolsa.BORRADOR,
  EstadoBolsa.ENVIADA,
  EstadoBolsa.GANADA,
  EstadoBolsa.PERDIDA,
  EstadoBolsa.VENCIDA,
  EstadoBolsa.ANULADA,
];

export const ESTADOS_LABEL: Record<EstadoBolsa, string> = {
  [EstadoBolsa.ACTIVA]: 'Activa',
  [EstadoBolsa.BORRADOR]: 'Borrador',
  [EstadoBolsa.ENVIADA]: 'Enviada',
  [EstadoBolsa.GANADA]: 'Ganada',
  [EstadoBolsa.PERDIDA]: 'Perdida',
  [EstadoBolsa.VENCIDA]: 'Vencida',
  [EstadoBolsa.ANULADA]: 'Anulada',
  [EstadoBolsa.DISCARDED]: 'Borrada',
};

export function esTransicionValida(estadoActual: EstadoBolsa, estadoNuevo: EstadoBolsa): boolean {
  return TRANSICIONES_VALIDAS[estadoActual].includes(estadoNuevo);
}

export function esTransicionSoloSistema(estadoActual: EstadoBolsa, estadoNuevo: EstadoBolsa): boolean {
  return (TRANSICIONES_SOLO_SISTEMA[estadoActual] ?? []).includes(estadoNuevo);
}

export function transicionesPermitidas(estadoActual: EstadoBolsa): EstadoBolsa[] {
  return TRANSICIONES_VALIDAS[estadoActual];
}
